import React, { useState, useEffect } from 'react'
export const Share = ({ classes }) => {
  const [currentUrl, setCurrentUrl] = useState('')
  useEffect(() => {
    if (window) {
      setCurrentUrl(window.location.href)
    }
  }, [currentUrl])
  return (
    <div className={`zg-share d-flex align-items-center gap-4 ${classes}`}>
      <a className="zg-social-icon" aria-label="Share on X"
         href={`https://twitter.com/intent/tweet?url=${currentUrl}`}
         target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" className="w-100 h-auto">
          <use xlinkHref="#icon-x-solid"/>
        </svg>
      </a>
      <a className="zg-social-icon" aria-label="Share in Discord" href={`https://discord.com/invite/rootstock`} target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" className="w-100 h-auto">
          <use xlinkHref="#icon-discord-solid"/>
        </svg>
      </a>
      <a className="zg-social-icon" aria-label="Share on Linkedin"
         href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`}
         target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" className="w-100 h-auto">
          <use xlinkHref="#icon-linkedin-solid"/>
        </svg>
      </a>
    </div>
  )
}